// removed by extract-text-webpack-plugin
module.exports = {"container":"_3V4I-88tiW895KW3sOLG1d","title":"_2g8rb5DpnBi2MST5_Zm0NQ","message":"_3P9gakghk3Wlqop4wom2LB"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Home/Home/Reasons/styles.css
// module id = 1056
// module chunks = 21